import React from 'react'
import * as yup from 'yup'

import { Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import styles from 'global/modal.module.scss'

import Button from 'components/Button'
import Modal from 'components/Modal'
import FormControl from 'components/Form/FormControl'
import { STANDARD_URL } from 'utils/regex/patterns'

const editLinkFormSchema = yup.object().shape({
  title: yup
    .string()
    .required(`Please enter url title`)
    .max(
      150,
      'Entry is above character maximum, please reduce the length before saving'
    ),
  url: yup
    .string()
    .matches(STANDARD_URL, {
      message: 'Please enter a valid URL'
    })
    .required('Please enter a URL')
})

const EditLink = ({
  show,
  closeModal,
  initialValues,
  onSubmit
}) => {
  const currItemId = initialValues?.id
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(editLinkFormSchema)
  })

  const formSubmit = payload => {
    onSubmit(currItemId, payload)
    closeModal()
  }

  return (
    <>
      <Modal
        mimicNative
        bodyClassName={styles.modal}
        show={show}
        title="Edit Link"
        closeModal={closeModal}
      >
        <p className={`${styles.title} d-none d-sm-block`}>
          Edit Link
        </p>
        <p className="text-gray-dark mb-20">
          Include a link that you&apos;d like to have easy access
          to related your coaching sessions.
        </p>
        <Form
          onSubmit={handleSubmit(formSubmit)}
          className="mb-40"
        >
          <FormControl
            inputRef={register}
            type="string"
            name="title"
            defaultValue={initialValues?.title}
            as="textarea"
            rows={2}
            placeholder="Link Title"
            error={errors.title}
          />
          <FormControl
            inputRef={register}
            type="string"
            name="url"
            defaultValue={initialValues?.url}
            placeholder="Paste URL here"
            error={errors.url}
          />
        </Form>
        <div className="d-flex justify-content-end mb-20">
          <Button
            className="d-none d-sm-block"
            variant="url"
            smallPadding
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            className="form__button--submit"
            variant="secondary"
            smallPadding
            onClick={handleSubmit(formSubmit)}
          >
            Edit Link
          </Button>
        </div>
      </Modal>
    </>
  )
}

EditLink.propTypes = {}

export default EditLink
